<template>
  
  <codemirror ref="queryEditor"
              :value="sparqlQuery" 
              :options="cmOptions"
              @ready="onCmReady"
              @focus="onCmFocus"
              @input="onCmCodeChange"
              id="codeMirrorElement">
  </codemirror>
 
</template>
 
<script>
// source: https://www.npmjs.com/package/vue-codemirror

import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/theme/base16-dark.css'

export default {

  data () {
    return {

      // editor options
      cmOptions: {
        tabSize: 4,
        mode: 'text/javascript',
        theme: 'base16-dark',
        lineNumbers: true,
        line: true,
        styleSelectedText: true,
        matchBrackets: true,
        showCursorWhenSelecting: true,
        viewportMargin: Infinity 
      }
    }
  },
  props: ["code"],      // this one is sent by the parent component
  methods: {
    onCmReady(cm) {
      // the editor is ready!
    },
    onCmFocus(cm) {
      // the editor has focus!
    },
    onCmCodeChange(newSparqlQuery) {      
      // the content of the editor has changed, send the value back to the parent component
      this.$emit('editor_input', newSparqlQuery);
    }
  },
  computed: {
    codemirror() {
      return this.$refs.queryEditor.codemirror
    },
    sparqlQuery(){
      // Good practice is to insert the value sent by the parent component into a local variable in the child component.
      // That way, the user's input in the editor represents another variable than the one sent by the parent. Which allows
      // the user to edit it. The edited value is sent back to the parent at each key strike (onCmCodeChange method), and
      // re-injected by this very computed method.
      return this.code;
    }
  },
  mounted() {
    // this is current codemirror object: this.codemirror
    // we can use this.codemirror to do something, if needed...
  }
}
</script>

<style>
#codeMirrorElement {
  height: auto
}
</style>


// WEBPACK FOOTER //
// src/components/QueryEditor.vue